import { RouteRecordRaw } from 'vue-router';
import { ssoCheck } from '@/common/router/navigationGuard';
import { normalizeQueryStringParam } from '@/common/router/router.utils';

const ssoMenu: RouteRecordRaw[] = [
  {
    path: '/sso',
    component: () => import('../views/SsoView.vue'),
    props: (route) => ({
      id: route?.query?.id,
      error: route?.query?.error,
      errorCode: route?.query?.errorCode,
      redirectPath: normalizeQueryStringParam(route?.query?.redirectPath),
    }),
    beforeEnter: ssoCheck,
  },
  {
    path: '/sso-login',
    component: () => import(/* webpackChunkName: "sso-login" */ '../views/SsoView.vue'),
    props: (route) => ({
      id: route?.query?.id,
      error: route?.query?.error,
      errorCode: route?.query?.errorCode,
      redirectPath: normalizeQueryStringParam(route?.query?.redirectPath),
    }),
    beforeEnter: ssoCheck,
  },
];

export { ssoMenu };
